import React, {useCallback, useContext} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {CriteriaStrip} from 'src/components/criteria-strip';
import {selectCriteriaStripView} from 'src/components/criteria-strip/services/criteria-strip-slice';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {FlatButton} from '@pb/kit-component-button';
import {Integer} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';
import {LocaleContext} from '@pb/kit-context-locale';
import {pluralize} from '@pb/kit-formatters';

import {
    userSearchResultHeader,
    userSearchResultHeaderLiveCount,
    userSearchResultHeaderSeparator,
} from './user-search-result-header.module.styl';


type Props = {
    searchId: string,
    totalCount: number,
};

export const UserSearchResultHeader = ({searchId, totalCount}: Props) => {
    const navigate = useNavigate();
    const {locale} = useContext(LocaleContext);
    const {searchCriteriaOpen} = useEventTracking();

    const stripData = useSelector(selectCriteriaStripView);

    const onOpenCriteria = useCallback(() => {
        searchCriteriaOpen({place: 'Modify Criteria Button'});
        navigate(`/search-criteria/${searchId}/users`);
    }, [searchId, navigate, searchCriteriaOpen]);

    return (
        <Group direction="v" gap="m" className={userSearchResultHeader} alignItems="start">
            <Group alignItems="center">
                <Typography variant="heading-level-1">Users Search</Typography>
                {totalCount ? (
                    <span className={userSearchResultHeaderSeparator}/>
                ) : null}
                {totalCount ? (
                    <Group gap="s" className={userSearchResultHeaderLiveCount}>
                        <span>
                            {Integer.format(totalCount, locale, {showZeros: true})}
                        </span>
                        <span>
                            {pluralize(`User[s]`, totalCount)}
                        </span>
                    </Group>
                ) : null}
            </Group>
            <Group gap="m" direction="v" alignItems="start">
                <FlatButton
                    disabled={false}
                    onClick={onOpenCriteria}>
                    <strong>
                        Modify Criteria ({stripData?.length})
                    </strong>
                </FlatButton>
                <CriteriaStrip activeTab="users"/>
            </Group>
        </Group>
    );
};

